import React from 'react';
import OptionButton from '../OptionButton';

const Step2 = ({ data, onSelect, overrides }) => {
  const options = overrides?.options || [
    'Persistent fatigue or low energy',
    'Brain fog or difficulty concentrating',
    'Weight gain or difficulty losing weight',
    'Cold sensitivity',
    'Hair thinning or dry skin',
    'Other'
  ];

  const toggleSelection = (option) => {
    const currentSelections = data.symptoms || [];
    const isSelected = currentSelections.includes(option);
    
    let newSelections;
    if (isSelected) {
      newSelections = currentSelections.filter(item => item !== option);
    } else {
      newSelections = [...currentSelections, option];
    }
    
    onSelect('symptoms', newSelections);
  };

  const isSelected = (option) => {
    return (data.symptoms || []).includes(option);
  };

  return (
    <div className="flex flex-col">
      {/* Question */}
      <h1 className="font-serif text-4xl md:text-5xl leading-tight mb-3" style={{ color: '#1a1a2e' }}>
        {overrides?.question || 'Do you experience any of these symptoms?'}
      </h1>
      
      {/* Subtext */}
      <p className="text-base mb-8" style={{ color: '#666' }}>
        {overrides?.subtitle || 'Select all that apply.'}
      </p>

      {/* Options */}
      <div className="flex flex-col gap-3 items-start">
        {options.map((option) => (
          <OptionButton
            key={option}
            selected={isSelected(option)}
            onClick={() => toggleSelection(option)}
          >
            {option}
          </OptionButton>
        ))}
      </div>
    </div>
  );
};

export default Step2;
